((scope) => {
  const zone = 'America/New_York';
  const day = 86400000;
  function calendarDate(year, month, date) { return new Date(Date.UTC(year, month, date, 12)); }
  function holidayDates(year) {
    const dates = new Set();
    const key = date => date.toISOString().slice(0, 10);
    const fixed = (month, date) => {
      const actual = calendarDate(year, month, date);
      dates.add(key(actual));
      if (actual.getUTCDay() === 6) dates.add(key(new Date(+actual - day)));
      if (actual.getUTCDay() === 0) dates.add(key(new Date(+actual + day)));
    };
    const weekday = (month, week, target) => {
      const first = calendarDate(year, month, 1);
      dates.add(key(calendarDate(year, month, 1 + (target - first.getUTCDay() + 7) % 7 + (week - 1) * 7)));
    };
    fixed(0, 1); fixed(5, 19); fixed(6, 4); fixed(10, 11); fixed(11, 25);
    weekday(0, 3, 1); weekday(1, 3, 1); weekday(8, 1, 1); weekday(9, 2, 1); weekday(10, 4, 4);
    const mayEnd = calendarDate(year, 4, 31);
    dates.add(key(calendarDate(year, 4, 31 - (mayEnd.getUTCDay() + 6) % 7)));
    return dates;
  }
  function estimate(now = new Date(), service = 'standard') {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: zone, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' }).formatToParts(now).map(part => [part.type, part.value]));
    let dispatch = calendarDate(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
    const holidays = new Set([Number(parts.year) - 1, Number(parts.year), Number(parts.year) + 1].flatMap(year => [...holidayDates(year)]));
    const isHoliday = date => holidays.has(date.toISOString().slice(0, 10));
    if (Number(parts.hour) >= 12) dispatch = new Date(+dispatch + day);
    while (![1, 3, 5].includes(dispatch.getUTCDay()) || isHoliday(dispatch)) dispatch = new Date(+dispatch + day);
    function transit(count) {
      let date = new Date(dispatch);
      while (count > 0) {
        date = new Date(+date + day);
        const weekday = date.getUTCDay();
        if (weekday !== 0 && (service === 'standard' || weekday !== 6) && !isHoliday(date)) count--;
      }
      return date;
    }
    return { earliest: transit(service === 'express' ? 2 : 3), latest: transit(service === 'express' ? 2 : 5) };
  }
  scope.ROTDelivery = { estimate };
  if (!scope.document) return;
  const document = scope.document;
  function init(root) {
    const widget = root.querySelector('[data-rot-delivery]');
    if (!widget || widget.dataset.ready) return;
    widget.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-rot-product-data]').textContent);
    const service = widget.querySelector('select');
    function render() {
      const selected = data.variants.find(variant => String(variant.id) === root.querySelector('.rot-product-form [name="id"]')?.value);
      const selectedSize = root.querySelector('[data-rot-size][aria-pressed="true"]');
      const available = selectedSize ? selected?.available : data.variants.some(variant => variant.available);
      const eligible = widget.dataset.country === 'US';
      let text = widget.dataset.international;
      let compact = text;
      if (eligible && !available) text = compact = widget.dataset.unavailable;
      if (eligible && available) {
        const result = estimate(new Date(), service.value);
        const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
        const start = format.format(result.earliest), end = format.format(result.latest);
        const dates = start === end ? start : start + '–' + end;
        text = (service.value === 'express' ? widget.dataset.express : widget.dataset.standard).replace('[dates]', dates);
        compact = (service.value === 'express' ? widget.dataset.compactExpress : widget.dataset.compactStandard).replace('[dates]', dates);
      }
      widget.querySelectorAll('[data-rot-delivery-estimate]').forEach(node => node.textContent = text);
      widget.querySelector('[data-rot-delivery-compact]').textContent = compact;
      service.disabled = !eligible || !available;
    }
    service.addEventListener('change', render);
    root.addEventListener('rot:variant-change', render);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) render(); });
    widget.addEventListener('click', render);
    setInterval(render, 60000);
    render();
  }
  function boot() { document.querySelectorAll('[data-rot-product]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('rot:product-ready', boot);
  boot();
})(typeof window === 'undefined' ? globalThis : window);
